// import templateUtil from "./templateUtil"
// import compileVariableUtil from "../../../static/js/compileVariableUtil"
import ajaxPost from './converterAdapter/ajaxPost'
import dynamicRange from './converterAdapter/dynamicRange'
import objectRefer from './converterAdapter/objectRefer'
import equalExpression from './converterAdapter/equalExpression'

import objectUtil from '../../../static/js/objectUtil'
/**
动态表单协议转换工具类
ver 1.0.0
@author liumingquan
修改记录：
  2018-6-12：
*/

var validateConverterUtil = {}

// 数据类型转换。后台定义数据类型转换成 验证框架要求格式。 不用float ，验证框架对float验证不严谨。 bug源码如下： return types.number(value) && !types.integer(value);
const serviceType = {
  OBJECT_REFER: 'objectRefer',
  DATE_PERIOD: 'array',
  ARRAY: 'array',
  FLOAT: 'number',
  DOUBLE: 'number',
  DECIMAL: 'number',
  MONEY: 'number',
  STRING: 'string',
  STRING_L1: 'string',
  STRING_L2: 'string',
  STRING_L3: 'string',
  LONG: 'number',
  TIME: 'string',
  DATETIME: 'string',
  BOOLEAN: 'boolean',
  INTEGER: 'integer',
  // "DATE": "date",
  DATE: 'string',
  OBJECT: 'object',
}

/**
 特殊协议转换适配器，定义类。
 属性名使用 组件类型。
 groupLabel：特殊转换器，1.显示名优先注入到标题。2.支持锚点提取
*/

validateConverterUtil.converterAdapter = {
  ajaxPost,
  dynamicRange,
  objectRefer,
  equalExpression,
}

/**
 * 将每个定义表单输入控件，转换成组件要求的协议。
 * @param {array} validateArray scc后台定义结构体的元素列表
 * @param {object} fCreateApi 动态表单api

 * @return {array} items 转换成form-create 要求的结构体

 */
validateConverterUtil.converterValidates = function (validateArray, formItem, fCreateApi) {
  // if (!validateArray) return validateArray;
  // console.log("validateConverterUtil.converterValidates:validateArray");

  //
  //
  // var propsCompileData = compileVariableUtil.getCompileVariable(fCreateApi.getFormData(),
  //   this);
  //
  // let propsCompile = null;
  // try {
  //   propsCompile = templateUtil.compileData(validateArray, propsCompileData);
  // } catch (e) {
  //   // propsCompile = props;
  //   // debugger;
  // }
  //
  // if (propsCompile) validateArray = propsCompile;

  var isRequired = false
  if (validateArray) {
    // if (formItem.required && validateArray.length > 0) {
    //   validateArray[0].required = true
    // }
    for (var i = 0; i < validateArray.length; i++) {
      const validateItem = validateArray[i]

      if (validateItem.required) {
        isRequired = true
        validateConverterUtil.converterAdapterOfRequired(validateItem, formItem)
      }
      // 兼容后台配置，max不填写时候自动设置为0，导致严重max为0问题。
      if (validateItem.max === 0) {
        delete validateItem.max
      }
      if (validateItem.len === 0) {
        delete validateItem.len
      }
      if (!validateItem.trigger) {
        validateItem.trigger = 'blur'
      }
      let tempType = validateItem.type || validateItem.customType //用于取缓存数据时type为null，导致不执行该方法从而取不到formData
      const converterAdapter = validateConverterUtil.converterAdapter[tempType]
      if (typeof converterAdapter === 'function') {
        converterAdapter(validateItem, formItem, fCreateApi)
      }
    }
  }

  // 如果验证规则数组中，没有定义必填项，则根据元素定义中是否设置必填项。
  if (!isRequired) {
    // 数据类型

    if (formItem.required) {
      //  console.log("isRequired", formItem.required, formItem);
      var type = validateConverterUtil.getValidatorTypeOfServiceType(
        formItem.typeCode ?? formItem?.type?.code
      )
      const validateItem = {
        required: true,
        type: type,
        trigger: 'blur',
      }

      const converterAdapter = validateConverterUtil.converterAdapter[validateItem.type]
      if (typeof converterAdapter === 'function') {
        converterAdapter(validateItem, formItem, fCreateApi)
      } else if (formItem.props?.validateKeys || formItem.parameter?.validateKeys) {
        //解决当使用复合组件（如validDateCompute组件）时自定义必填校验失败
        validateItem.validator = function (rule, value, callback) {
          let validateFlag = true
          let msg = '必填'
          const validateKeys = formItem.props?.validateKeys || formItem.parameter?.validateKeys
          for (const item of validateKeys) {
            const childVal = objectUtil.getValueByPath(value, item)
            if (!childVal && childVal !== 0 && childVal !== false) {
              validateFlag = false
              break
            }
          }

          if (validateFlag) {
            if (callback) callback()
          } else {
            if (callback) callback(new Error(msg))
          }
        }
      }

      validateConverterUtil.converterAdapterOfRequired(validateItem, formItem)
      if (!validateArray) validateArray = []
      validateArray = [validateItem, ...validateArray]
      // validateArray.push(validateItem)
    }
  }
  // console.log('formItem.typeCode', validateItem);
  return validateArray || []
}

/**
  数据类型转换。后台定义数据类型转换成 验证框架要求格式。

string: Must be of type string. This is the default type.
number: Must be of type number.
boolean: Must be of type boolean.
method: Must be of type function.
regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
integer: Must be of type number and an integer.
float: Must be of type number and a floating point number.
array: Must be an array as determined by Array.isArray.
object: Must be of type object and not Array.isArray.
enum: Value must exist in the enum.
date: Value must be valid as determined by Date
url: Must be of type url.
hex: Must be of type hex.
email: Must be of type email.
*/

validateConverterUtil.getValidatorTypeOfServiceType = function (typeCode) {
  if (!typeCode) return 'string'
  var data = serviceType[typeCode]
  if (!data) data = 'string'
  return data
}

/**
  对于必填做特殊处理
*/
validateConverterUtil.converterAdapterOfRequired = function (validateItem) {
  if (validateItem.required) {
    // 必填项设置默认值。
    if (!validateItem.message) {
      validateItem.message = '必填'
    }
  }

  return validateItem
}

export default validateConverterUtil
